<template>
  <div class="recharge_left capital_first">
    <el-card class="box-card common-bg" shadow="never">
      <div>
        <el-button
          size="mini"
          type="danger"
          style="
            position: absolute;
            z-index: 100;
            right: 21px;
            border-radius: 5px;
          "
          class="button_red_color"
          @click="getServerUrl()"
          >在线客服</el-button
        >
      </div>
      <div slot="header" class="clearfix">
        <h3>我的账户</h3>
        <!--        <el-button type="primary" style="float: right" @click="goDetailed">充值记录</el-button>-->
      </div>
      <el-tabs @tab-click="handleClick" v-model="activeName">
        <el-tab-pane name="recharge">
          <span slot="label"><i class="el-icon-coin" /> 充值</span>
          <el-card class="box-card" shadow="never">
            <el-row>
              <el-col :span="12" :offset="1">
                <el-form ref="form" label-width="100px" size="small">
                  <h4 style="margin: 20px 0; width: 600px">
                    <div style="padding-left: 27px" v-html="notice_1_1"></div>
                    <!-- &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;充值须知：<br />
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1、请每一次充值必须获取最新帐号，以免充值无效。<br />
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2、请必须使用本人帐号充值，避免查不到账。<br />
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3、转账成功后点“我已转账，申请充值”，平台确认后到账。<br />
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4、单笔充值请勿超过4.5万，充值4.5万以上请联系客服申请大额充值帐户。<br />
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;5、单笔充值20万以上，请提前一天联系客服申请vip充值帐户。<br /> -->
                    <!-- <el-row>
                      <el-col :span="3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1、</el-col>
                      <el-col :span="21">请每一次充值必须获取最新帐号，以免充值无效。<br /></el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2、</el-col>
                      <el-col :span="21">请必须使用本人帐号充值，避免查不到账。<br /></el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3、</el-col>
                      <el-col :span="21">转账成功后点“我已转账，申请充值”，平台确认后到账。<br /></el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4、</el-col>
                      <el-col :span="21">单笔充值请勿超过4.5万，充值4.5万以上请联系客服申请大额充值帐户。<br /></el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;5、</el-col>
                      <el-col :span="21">单笔充值20万以上，请提前一天联系客服申请vip充值帐户。<br /></el-col>
                    </el-row> -->
                  </h4>
                  <el-form-item prop="money">
                    <span slot="label" class="weigth">充值金额:</span>
                    <el-input
                      type="text"
                      v-model="recharge.number"
                      maxlength="7"
                      placeholder="请填写充值金额"
                      onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
                      onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
                      v-bind:disabled="isAutoAmounts == true ? true : false"
                    />
                  </el-form-item>
                  <el-row
                    v-for="(item, index) in auto_fill_amounts"
                    :key="index"
                    style="margin-left: 100px;"
                  >
                    <el-col
                      :span="6"
                      v-for="(item1, index1) in item"
                      :key="index1"
                    >
                      <el-button
                        round
                        size="large"
                        @click="handleAmount(item1)"
                        style="border-color: #D02E27; color: #D02E27; margin-bottom: 10px; background: #ffffff;"
                        >{{ item1 }}元</el-button
                      >
                    </el-col>
                  </el-row>
                  <el-form-item v-if="isRechargeMethodShow == 1">
                    <span class="weigth" slot="label">充值方式:</span>
                    <button
                      type="button"
                      class="recharge-visibility-btn"
                      :class="{ 'is-collapsed': methodSectionHidden }"
                      @click="toggleMethodSection"
                    >{{ methodSectionHidden ? "显示" : "隐藏" }}</button>
                    <div v-show="!methodSectionHidden" class="recharge-filter-grid">
                      <button
                        type="button"
                        class="recharge-filter-btn"
                        :class="{ 'is-selected': selectedMethod === null }"
                        @click="selectRechargeMethod(null)"
                      >全部</button>
                      <button
                        v-for="item in rechargeMethodOptions"
                        :key="item.key"
                        type="button"
                        class="recharge-filter-btn"
                        :class="{ 'is-selected': selectedMethod === item.value }"
                        @click="selectRechargeMethod(item.value)"
                      >{{ item.label }}</button>
                    </div>
                  </el-form-item>
                  <el-form-item v-if="isRechargeChannelShow == 1">
                    <span class="weigth" slot="label">充值通道:</span>
                    <button
                      type="button"
                      class="recharge-visibility-btn"
                      :class="{ 'is-collapsed': channelSectionHidden }"
                      @click="toggleChannelSection"
                    >{{ channelSectionHidden ? "显示" : "隐藏" }}</button>
                    <div v-show="!channelSectionHidden" class="recharge-filter-grid">
                      <button
                        type="button"
                        class="recharge-filter-btn"
                        :class="{ 'is-selected': selectedChannel === null }"
                        @click="selectRechargeChannel(null)"
                      >全部</button>
                      <button
                        v-for="item in rechargeSourceOptions"
                        :key="item.key"
                        type="button"
                        class="recharge-filter-btn"
                        :class="{ 'is-selected': selectedChannel === item.id }"
                        @click="selectRechargeChannel(item.id)"
                      >{{ item.name }}</button>
                    </div>
                  </el-form-item>
                  <el-form-item>
                    <span class="weigth" slot="label">{{ rechargeFilterMode ? "充值名称:" : "充值方式:" }}</span>
                    <div
                      v-if="rechargeListReady && rechargeFilterMode && rechargeType.length === 0"
                      class="recharge-empty-tip"
                    >请联系客服</div>
                    <el-radio-group v-else v-model="radio" size="medium" class="recharge-type-group">
                      <el-radio
                        v-for="(item, index) in rechargeType"
                        :key="item.id != null ? item.id : index"
                        :label="index"
                        border
                        class="rechargeRadio"
                        :class="{ 'has-latest': item.latest_recharge == 1 }"
                        @change="changeInstructions(index)"
                        ><i class="el-icon-bank-card"></i>
                        <span class="recharge-type-label">{{ item.name }}
                          <small v-if="item.latest_recharge == 1" class="recharge-latest">上次选择</small>
                        </span>
                      </el-radio>
                    </el-radio-group>
                  </el-form-item>

                  <h4
                    v-if="maxCouponCheck"
                    style="
                      margin: 20px 0;
                      font-size: 14px;
                      color: #626066;
                      padding-left: 100px;
                    "
                  >
                    充值满{{ coupounAmount * 10 }}送{{
                      coupounAmount
                    }}
                    有效期：{{ effectiveDate }}
                  </h4>

                  <el-form-item>
                    <!--                    <el-button type="primary" >取消充值</el-button>-->
                    <el-button
                      type="danger"
                      @click="rechargeNext"
                      :disabled="disabled4"
                      class="button_red_color"
                      >下一步<br /><br />获取实时入款卡,请自行通过手机/电脑/银行转账
                    </el-button>
                  </el-form-item>
                </el-form>
              </el-col>
            </el-row>
          </el-card>
          <br />
          <el-card class="box-card" shadow="never">
            <div v-html="data"></div>
            <!--<div class="assist">
              <p class="red">活动专区:</p>
              <p class="red">新会员首次充值 巨额返现 可提现</p>
              <table>
                <tr>
                  <th>新会员首冲额(须配资)</th>
                  <th>返现金额(可提现)</th>
                </tr>
                <tr>
                  <td>1000元</td>
                  <td>188元</td>
                </tr>
                <tr>
                  <td>5000元</td>
                  <td>466元</td>
                </tr>
                <tr>
                  <td>10000元</td>
                  <td>888元</td>
                </tr>
                <tr>
                  <td>50000元</td>
                  <td>4666元</td>
                </tr>
                <tr>
                  <td>10万元以上</td>
                  <td>8888元</td>
                </tr>
              </table>
              <p>提示:</p>
              <p>首冲须全额配资后提现,可分次累计</p>
              <p>若首冲不配资,向客服申请扣减返现后,可提现</p>
              <p class="red">任何会员推荐新会员首次充值 推荐人同样奖励 可提现</p>
              <table>
                <tr>
                  <th>新会员首冲额(须配资)</th>
                  <th>推荐人奖励(满100可提现)</th>
                </tr>
                <tr>
                  <td>100-999元</td>
                  <td>10元</td>
                </tr>
                <tr>
                  <td>1000元</td>
                  <td>88元</td>
                </tr>
                <tr>
                  <td>5000元</td>
                  <td>466元</td>
                </tr>
                <tr>
                  <td>10000元</td>
                  <td>888元</td>
                </tr>
                <tr>
                  <td>50000元</td>
                  <td>4666元</td>
                </tr>
                <tr>
                  <td>10万元以上</td>
                  <td>8888元</td>
                </tr>
              </table>
              <p>提示:</p>
              <p>新会员首冲若不配资而提现,推荐人奖励将被自动扣减</p>
              <p class="red">双方受益 利人利己</p>
              <p>本次活动有效期和最终解释权归属大牛证券所有</p>
            </div>-->
          </el-card>
          <br />
          <!--<el-card class="box-card" shadow="never">
            <div class="assist">
              <p class="red">到账时间:</p>
              <p>09:00-17:30(5-30分钟到账)</p>
              <p>17:30以后或节假日(下个开市日09:00前到账)</p>
            </div>
          </el-card>-->
        </el-tab-pane>
        <el-tab-pane name="withdraw">
          <span slot="label"><i class="el-icon-bank-card"></i> 提现</span>
          <el-card class="box-card" shadow="never">
            <el-row >
              <el-col :span="12" :offset="1">
                <el-form
                  ref="form"
                  :model="withdrawalData"
                  label-width="100px"
                  size="small"
                >
                  <el-form-item label-width="0" >
                    <h3 v-if="selected_type != 3 && selected_type != 4">
                      请务必用本人({{
                        withdrawalData.account
                      }})名字的银行卡提款!
                      <el-button
                        type="primary"
                        class="right button_blue_color"
                        @click="bankCardState = true"
                        >银行卡管理</el-button
                      >
                    </h3>
                  </el-form-item>
                  <el-form-item v-if="selected_type != 3 && selected_type != 4">
                    <h4 slot="label">银行名称:</h4>
                    <p>{{ withdrawalData.name }}</p>
                  </el-form-item>
                  <el-form-item v-if="selected_type != 3 && selected_type != 4">
                    <h4 slot="label">开户支行:</h4>
                    <p>{{ withdrawalData.address }}</p>
                  </el-form-item>
                  <el-form-item v-if="selected_type != 3 && selected_type != 4">
                    <h4 slot="label">银行卡号:</h4>
                    <p>{{ withdrawalData.card }}</p>
                  </el-form-item>
                  <el-form-item v-if="selected_type != 3 && selected_type != 4">
                    <h4 slot="label">开户姓名:</h4>
                    <p>{{ withdrawalData.account }}</p>
                  </el-form-item>
                  <el-form-item label-width="0" >
                    <h3 v-if="selected_type==3" style="width: 800px;">
                     请务必确认提币地址和转账网络的准确性, 避免您的资产丢失。</h3>
                  </el-form-item>
                   <el-form-item v-if="selected_type==3">
                    <h4 slot="label">网络 :</h4>
                    <p>Tron (TRC20)</p>
                    <h4 slot="label">提币地址:</h4>
                    <p>{{ usdt.user_withdraw_address }}</p>
                  </el-form-item>
                  <br /><br />
                  <el-form-item label-width="0">
                    <h3>
                      请选择提现账号
                      <el-button
                        type="primary"
                        class="right button_blue_color"
                        @click="withdrawalState = true"
                        >修改提现密码</el-button
                      >
                    </h3>
                  </el-form-item>
                  <el-form-item>
                    <h4 slot="label">账户金额:</h4>
                    <p>{{ withdrawalData.cash }}元</p>
                  </el-form-item>
                  <el-form-item>
                    <h4 slot="label">提现金额:</h4>
                    <el-input
                      type="text"
                      maxlength="7"
                      v-model="withdrawalData.money"
                      placeholder="请填写提现金额"
                      /> 
                    <el-row>
                       
                      <el-col :span="12">
                        <!-- <p id="minAmountDisplay" style="float:left;margin-right:70px;"></p> -->
                        <p style="float:left;margin-right:10px;">提现100元的整倍数起</p>
                        </el-col>
                        <el-col :span="11">
                          <p class="text_red_color" style="color:red;margin-right: 5px;text-align-last: end;" v-if="is_non_withdrawable==1"><span class="text_red_color"> 可提现额：{{ withdrawable_amount }}元 </span></p>
                      </el-col>
                      <el-col :span="1">
                          <p class="text_red_color" style="color:red;" v-if="is_non_withdrawable==1"><span><i class="el-icon-question #D02E27" @click="showPopup()"></i></span></p>
                      </el-col>
                        </el-row>
                          
                  </el-form-item>
                    <el-form-item v-if="selected_type == 3">
                    <h4 slot="label">USDT: </h4>
                  <div style="display: flex; align-items: center; gap: 8px;">
                  <p id="usdt_amount"></p>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                   <h4 >汇率: </h4>
                  <p>{{ usdt.exchange_rate }}</p>
                </div>
                  </el-form-item>
                  <el-form-item v-if="selected_type == 4 && wpayLinked" label-width="0">
                    <h3>提现将转入已绑定的 WPay 账户</h3>
                  </el-form-item>
                  <el-form-item v-if="selected_type == 2">
                    <h4 slot="label">Gxpay ID:</h4>
                    <el-input
                      type="text"
                      v-model="withdrawalData.gxpay_id"
                      placeholder="请输入Gxpay ID"
                    />
                    <div class="checked">
                      <el-checkbox
                        v-model="withdrawalData.checked"
                        label="已核对确认"
                        size="large"
                      />
                    </div>
                  </el-form-item>
                  <el-form-item>
                    <div style="width: 600px; font-size: 14px;">
                      <div v-html="notice_1_10"></div>
                    </div>
                  </el-form-item>
                  <el-row
                    v-for="(item, index) in auto_fill_amounts_withdraw"
                    :key="index"
                    style="margin-left: 100px;"
                  >
                    <el-col
                      :span="6"
                      v-for="(item1, index1) in item"
                      :key="index1"
                    >
                      <el-button
                        round
                        size="small"
                        @click="handleWithdrawAmount(item1)"
                        style="border-color: #D02E27; color: #D02E27; margin-bottom: 10px; background: #ffffff;"
                        >{{ item1 }}元</el-button
                      >
                    </el-col>
                  </el-row>
                  <el-form-item>
                    <span class="weigth" slot="label">提现方式:</span>
                    <el-radio-group v-model="radioW" size="medium">
                      <el-radio
                        v-for="(item, index) in withdraweType"
                        :key="index"
                        :label="index"
                        border
                        class="withdrawRadio"
                        @change="changeWithdrawInstructions(index)"
                        ><i class="el-icon-bank-card"></i>{{ item.name }}
                      </el-radio>
                    </el-radio-group>
                  </el-form-item>

                  <el-form-item>
                    <h4 slot="label">提现密码:</h4>
                    <el-input
                      v-model="withdrawalData.password"
                      placeholder="请填写提现密码"
                      show-password
                    ></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="danger" class="button_red_color" @click="withdraw_has" >确认提现  {{ button_text }}</el-button>
                  </el-form-item>
                </el-form>
              </el-col>
            </el-row>
          </el-card>
          <br />
          <!-- <el-card class="box-card" shadow="never">
            <div class="assist">
              <el-row
                v-if="withdraw_fee_percentage == 0 && withdraw_fee_min == 0"
              >
              </el-row>
              <el-row v-else>
                <el-col :span="24">
                  <p>
                    <span style="color: rgb(192, 0, 0)">温馨提醒：</span><br />
                    提现手续费按提现金额的{{ withdraw_fee_percentage }}%收取，{{
                      withdraw_fee_min
                    }}元起
                  </p>
                </el-col> -->
                <!-- <el-col :span="8">
                  <div>
                    <h4>闪电到账</h4>
                    <p>最快10分钟到账</p>
                    <p>安全 快捷</p>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div>-->
                <!--<h4>提现<span class="red">0</span>手续费</h4>
                    <p>提现产生的银行手续费全免</p>
                    <p>更多优质服务只在大牛证券配资平台官网</p> -->
                <!-- <h4>提现低手续费</h4>
                    <p>根据交易通道不同实行差别化收费</p>
                    <p>详情请咨询在线客服或专属客服</p>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div>
                    <h4>支持银行多达<span class="red">10</span>多家</h4>
                    <p>推荐您使用工商银行、建设银行</p>
                    <p>招商银行、农业银行提现,到账更快</p>
                  </div>
                </el-col> -->
              <!-- </el-row>
            </div>
          </el-card> -->
        </el-tab-pane>
        <!--<el-tab-pane>
          <span slot="label"><i class=" el-icon-copy-document"></i> 划转</span>
          <el-card class="box-card" shadow="never">
            <div class="assist">
              <el-row>
                <el-col :span="12" :offset="1">
                  <el-form ref="form" :model="recharge" label-width="100px" size="small">
                    <el-form-item>
                      <h4 slot="label">从代理账户:</h4>
                      <p>2100.00元</p>
                    </el-form-item>
                    <el-form-item>
                      <h4 slot="label">到本金账户:</h4>
                      <p>90000.00元</p>
                    </el-form-item>
                    <el-form-item>
                      <h4 slot="label">划转金额:</h4>
                      <el-input v-model="recharge.money" placeholder="请填写划转金额"></el-input>
                    </el-form-item>
                    <el-form-item>
                      <el-button type="danger">账户划转</el-button>
                    </el-form-item>
                  </el-form>
                </el-col>
              </el-row>
            </div>
          </el-card>
          <br>
          <el-card class="box-card" shadow="never">
            <div class="assist">
              <h4>划转即刻到账 无任何手续费</h4>
            </div>
          </el-card>
        </el-tab-pane>-->
      </el-tabs>
    </el-card>
    <!-- ============================== Start change channel popup ========================== -->
    <el-dialog
      :visible.sync="showTradeChannelPopup"
      width="40%"
      center
      :before-close="handleTradePopupClose"
    >
      <div v-html="trade_rules_content_top"></div>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          class="button_blue_color"
          @click="agreeTradeRules()"
          style="background: #ff0000; border-color: #ff0000; width: 200px"
          >我已经明白
        </el-button>
        <div
          v-html="trade_rules_content_bottom"
          style="padding-top: 10px"
        ></div>
      </span>
    </el-dialog>
    <!-- ============================== end change channel popup ========================== -->

    <!--    银行卡管理列表-->
    <el-dialog title="银行卡管理" :visible.sync="bankCardState" >
      <el-table :data="bankCardList">
        <el-table-column type="index" width="50"> </el-table-column>
        <el-table-column property="card" label="卡号"></el-table-column>
        <el-table-column property="name" label="银行名称"></el-table-column>
        <el-table-column property="address" label="开户支行"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              class="button_blue_color"
              @click="handleBankCard(scope.row)"
              >确定</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog
      title="充值通道"
      :close-on-click-modal="false"
      :visible.sync="topUpStatus"
      width="800px"
    >
      <el-form ref="form" label-width="100px">
        <el-button
          size="mini"
          type="danger"
          class="button_red_color"
          style="position: absolute; right: 49px; top: 20px; border-radius: 5px"
          @click="getServerUrl()"
          >在线客服</el-button
        >
        <!-- <div v-if="recharge.type == '8'">
          <el-form-item>
            <span class="weigth" slot="label">付款金额:</span>
            <p>联系在线客服<el-button type="text" class="right" @click="handleCopy(companyBank.name)">复制</el-button></p>
          </el-form-item>
          <el-form-item>
            <span class="weigth" slot="label">账户名称:</span>
            <p>联系在线客服<el-button type="text" class="right" @click="handleCopy(companyBank.name)">复制</el-button></p>
          </el-form-item>
          <el-form-item>
            <span class="weigth" slot="label">银行卡号:</span>
            <p>联系在线客服<el-button type="text" class="right" @click="handleCopy(companyBank.card)">复制</el-button></p>
          </el-form-item>
          <el-form-item>
            <span class="weigth" slot="label">银行名称:</span>
            <p>联系在线客服<el-button type="text" class="right" @click="handleCopy(companyBank.bank)">复制</el-button></p>
          </el-form-item>
          <el-form-item>
            <span class="weigth" slot="label">银行地址:</span>
            <p>联系在线客服<el-button type="text" class="right" @click="handleCopy(companyBank.address)">复制</el-button></p>
          </el-form-item>
          <div class="hint">
            <h3 class="red">温馨提示：</h3>
            <p>若10分钟内若未入款，请联系在线客服或专属客服。</p>
          </div>
        </div> -->
        <div v-if="recharge.type == '3'">
          <div class="notice-hint">
            <div v-html="notice_2_1"></div>
            <!-- <p>充值须知：</p>
            <p>1、请每一次充值必须获取最新帐号，以免充值无效。</p>
            <p>2、请必须使用本人帐号充值，避免查不到账。</p>
            <p>3、转账成功后点“我已转账，申请充值”，平台确认后到账。</p>
            <p>4、单笔充值请勿超过4.5万，充值4.5万以上请联系客服申请大额充值帐户。</p>
            <p>5、单笔充值20万以上，请提前一天联系客服申请vip充值帐户。</p> -->
          </div>
          <el-form-item>
            <span class="weigth" slot="label">付款金额:</span>
            <p>
              {{ recharge.number }}元
              <el-button
                type="text"
                class="right text_blue_color"
                @click="handleCopy(companyBank.name)"
                >复制</el-button
              >
            </p>
          </el-form-item>
          <el-form-item>
            <span class="weigth" slot="label">开户姓名:</span>
            <p>
              {{ companyBank.name }}
              <el-button
                type="text"
                class="right text_blue_color"
                @click="handleCopy(companyBank.name)"
                >复制</el-button
              >
            </p>
          </el-form-item>
          <el-form-item>
            <span class="weigth" slot="label">银行卡号:</span>
            <p>
              {{ companyBank.card }}
              <el-button
                type="text"
                class="right text_blue_color"
                @click="handleCopy(companyBank.card)"
                >复制</el-button
              >
            </p>
          </el-form-item>
          <el-form-item>
            <span class="weigth" slot="label">银行支行:</span>
            <p>
              {{ companyBank.bank }}
              <el-button
                type="text"
                class="right text_blue_color"
                @click="handleCopy(companyBank.bank)"
                >复制</el-button
              >
            </p>
          </el-form-item>
          <el-form-item>
            <span class="weigth" slot="label">银行地址:</span>
            <p>
              {{ companyBank.address }}
              <el-button
                type="text"
                class="right text_blue_color"
                @click="handleCopy(companyBank.address)"
                >复制</el-button
              >
            </p>
          </el-form-item>
          <div class="notice-hint">
            <div v-html="notice_2_2"></div>
            <!-- <h3 class="red">温馨提示：</h3>
            <p>若10分钟内若未入款，请联系在线客服或专属客服。</p> -->
          </div>
        </div>
        <div v-if="recharge.type == '6'">
          <div class="notice-hint">
            <div v-html="notice_2_1"></div>
            <!-- <p>充值须知：</p>
            <p>1、请勿保留旧卡转账，会造成无法充值。</p>
            <p>2、请用本人账号自行通过手机/电脑/银行向以下账号转账。</p>
            <p>3、转账成功后点“我已转账，申请充值”，平台确认后到账。</p>
            <p>4、转账金额须与系统一致，若有小数须带小数，否则次日到账。</p> -->
          </div>
          <el-form-item>
            <span class="weigth" slot="label">付款时间:</span>
            <p>
              请在<span class="red text_red_color">{{ time.endTime }}</span
              >之前付款
            </p>
          </el-form-item>
          <el-form-item>
            <span class="weigth" slot="label">付款金额:</span>
            <p>
              <span class="red text_red_color">{{ companyBank.money }}元</span
              >（须带小数与系统显示金额一致）
              <el-button
                type="text"
                class="right button_blue_color"
                @click="handleCopy(companyBank.money)"
                >复制</el-button
              >
            </p>
          </el-form-item>
          <el-form-item>
            <span class="weigth" slot="label">账户名称:</span>
            <p>
              {{ companyBank.name }}
              <el-button
                type="text"
                class="right button_blue_color"
                @click="handleCopy(companyBank.name)"
                >复制</el-button
              >
            </p>
          </el-form-item>
          <el-form-item>
            <span class="weigth" slot="label">银行卡号:</span>
            <p>
              {{ companyBank.card }}
              <el-button
                type="text"
                class="right button_blue_color"
                @click="handleCopy(companyBank.card)"
                >复制</el-button
              >
            </p>
          </el-form-item>
          <el-form-item>
            <span class="weigth" slot="label">银行名称:</span>
            <p>
              {{ companyBank.bank }}
              <el-button
                type="text"
                class="right button_blue_color"
                @click="handleCopy(companyBank.bank)"
                >复制</el-button
              >
            </p>
          </el-form-item>
          <div class="notice-hint">
            <div v-html="notice_2_2"></div>
            <!-- <h3 class="red">温馨提醒：</h3>
            <p>
              1-部分转账带小数是系统快速判断入款的需要，否则次日到账。举例提交100元，系统显示100.02元，请转100.02元即可到账。
            </p>
            <p>2-若10分钟内若未入款，请联系在线客服或专属客服。</p> -->
          </div>

          <!--<el-form-item>
            <p class="red" style="line-height: 1.5">温馨提醒：</p>
            <p class="red" style="line-height: 1.5">1-带小数的准确金额是为了确保您的转账金额的唯一性，系统以此判断区分是您的转账并自动入款，否则转人工审核，次日入款，将严重耽误您的到账时间。</p>
            <p class="red" style="line-height: 1.5">2-10分钟内转账将自动入款，若未入款，请联系在线客服或专属客服处理。</p>
            <p class="red" style="line-height: 1.5">3-请勿保留旧的银行卡号进行交易，否则将会导致资金无法到账，本站概不负责！</p>
          </el-form-item>-->
        </div>
        <div v-if="recharge.type == '7'">
          <iframe
            :src="recharge.url"
            frameborder="0"
            width="100%"
            height="600px"
          ></iframe>

          <!--<el-form-item>
            <p class="red" style="line-height: 1.5">温馨提醒：</p>
            <p class="red" style="line-height: 1.5">1-带小数的准确金额是为了确保您的转账金额的唯一性，系统以此判断区分是您的转账并自动入款，否则转人工审核，次日入款，将严重耽误您的到账时间。</p>
            <p class="red" style="line-height: 1.5">2-10分钟内转账将自动入款，若未入款，请联系在线客服或专属客服处理。</p>
            <p class="red" style="line-height: 1.5">3-请勿保留旧的银行卡号进行交易，否则将会导致资金无法到账，本站概不负责！</p>
          </el-form-item>-->
        </div>
        <div v-if="recharge.type == '8'">
          <div class="notice-hint">
            <div v-html="notice_2_1"></div>
            <!-- <p style="font-size: 16px; font-weight: bold">温馨提示：</p>
            <p style="font-size: 16px; font-weight: bold">自动入款每天限额</p>
            <p style="font-size: 16px; font-weight: bold">
              “多次获取不到银行卡”或者“充值一万以上”
            </p>
            <p style="font-size: 16px; font-weight: bold">
              请您联系在线客服获取最新银行卡。
            </p> -->
          </div>
          <iframe
            :src="recharge.url"
            frameborder="0"
            width="100%"
            height="600px"
          ></iframe>

          <!--<el-form-item>
            <p class="red" style="line-height: 1.5">温馨提醒：</p>
            <p class="red" style="line-height: 1.5">1-带小数的准确金额是为了确保您的转账金额的唯一性，系统以此判断区分是您的转账并自动入款，否则转人工审核，次日入款，将严重耽误您的到账时间。</p>
            <p class="red" style="line-height: 1.5">2-10分钟内转账将自动入款，若未入款，请联系在线客服或专属客服处理。</p>
            <p class="red" style="line-height: 1.5">3-请勿保留旧的银行卡号进行交易，否则将会导致资金无法到账，本站概不负责！</p>
          </el-form-item>-->
        </div>
        <div v-if="recharge.type == '9'">
          <div class="notice-hint">
            <div v-html="notice_2_1"></div>
            <!-- <p style="font-size: 16px; font-weight: bold">温馨提示：</p>
            <p style="font-size: 16px; font-weight: bold">自动入款每天限额</p>
            <p style="font-size: 16px; font-weight: bold">
              “多次获取不到银行卡”或者“充值一万以上”
            </p>
            <p style="font-size: 16px; font-weight: bold">
              请您联系在线客服获取最新银行卡。
            </p> -->
          </div>
          <iframe
            :src="recharge.url"
            frameborder="0"
            width="100%"
            height="600px"
          ></iframe>

          <!--<el-form-item>
            <p class="red" style="line-height: 1.5">温馨提醒：</p>
            <p class="red" style="line-height: 1.5">1-带小数的准确金额是为了确保您的转账金额的唯一性，系统以此判断区分是您的转账并自动入款，否则转人工审核，次日入款，将严重耽误您的到账时间。</p>
            <p class="red" style="line-height: 1.5">2-10分钟内转账将自动入款，若未入款，请联系在线客服或专属客服处理。</p>
            <p class="red" style="line-height: 1.5">3-请勿保留旧的银行卡号进行交易，否则将会导致资金无法到账，本站概不负责！</p>
          </el-form-item>-->
        </div>

        <div v-if="recharge.type == '12'">
          <div class="notice-hint">
            <div v-html="notice_2_1"></div>
            <!-- <p style="color: black; font-size: 19px">
              充值通道 数字货币-USDT(TRC20)
            </p>
            <br />
            <p>充值须知：</p>
            <p>1、重复支付、修改金额充值无法到账，概不负责。</p>
            <p>2、平台以到账数量为准，到账数量=转账数量-转账手续费。</p>
            <p>3、扫描二维码或复制地址充值，仅接受TRC20-USDT。</p> -->
            <br />

            <p
              style="width: 200px; text-align: left; color: black"
              class=""
              slot="label"
            >
              支付倒计时：<span id="countDown"></span>
            </p>
            <br />

            <el-form-item>
              <p
                style="
                  width: 200px;
                  text-align: left;
                  color: black;
                  line-height: 20px;
                "
                class=""
                slot="label"
              >
                请付<span style="color: red">{{ crypto.USDTAmount }}</span>
                USDT<br />
                到账金额{{ crypto.money }}元<br />
                USDT（TRC20）充值二维码
              </p>
              <p>
                <el-button
                  type="text"
                  class="right button_blue_color"
                  @click="handleCopy(crypto.USDTAmount)"
                  >复制</el-button
                >
              </p>
            </el-form-item>
            <div
              style="width: 670px; text-align: left"
              class="hint"
              slot="label"
            >
              <div id="qrcode" class="crypto_qrcode"></div>
            </div>
            <el-form-item>
              <p
                style="width: 400px; text-align: left; color: black"
                class="hint"
                slot="label"
              >
                USDT（TRC20）充值地址：<br />
                {{ crypto.qrCode }}
              </p>
              <el-button
                type="text"
                class="right button_blue_color"
                @click="handleCopy(crypto.qrCode)"
                >复制</el-button
              >
            </el-form-item>
            <div v-html="notice_2_2"></div>
            <!-- <p class="red">温馨提示：</p>
            <p>请转账后请截图发给在线客服或专属客服确认，申请充值。</p>
            <p>需等待1-15分钟，整个网络节点上有一定确认数后，才会实际到账。</p> -->
          </div>
        </div>
        <div v-if="recharge.type == '20'">
           <div class="notice-hint">
             <div v-html="notice_2_1"></div>
           </div>
           <div v-html="recharge.recharge_content"></div>
 
           <div class="notice-hint">
             <div v-html="notice_2_2"></div>
             <!-- <h3 class="red">温馨提示：</h3>
             <p>若10分钟内若未入款，请联系在线客服或专属客服。</p> -->
           </div>
         </div>
        <div v-if="recharge.type == '27'">
          <div class="notice-hint"><div v-html="notice_2_1"></div></div>
          <el-form-item>
            <span class="weigth" slot="label">支付宝账号:</span>
            <p>
              {{alipayInfo.alipay_account}}
              <el-button
                type="text"
                class="right text_blue_color"
                @click="handleCopy(alipayInfo.alipay_account)"
                >复制</el-button
              >
            </p>
          </el-form-item>
          <el-form-item>
            <span class="weigth" slot="label">支付宝姓名:</span>
            <p>
              {{ alipayInfo.alipay_name }}
              <el-button
                type="text"
                class="right text_blue_color"
                @click="handleCopy(alipayInfo.alipay_name)"
                >复制</el-button
              >
            </p>
          </el-form-item>
          <div >
            <img
          :src="alipayInfo.aiipay_qrcode"
          style="width: 100%"
        />
          </div>

          <div class="notice-hint">
            <div v-html="notice_2_2"></div>
            <!-- <h3 class="red">温馨提示：</h3>
             <p>若10分钟内若未入款，请联系在线客服或专属客服。</p> -->
          </div>
        </div>
        <!--<div v-if="recharge.type === '1'" class="recharge-img">
          <el-form-item>
            <el-image
              style="width: 200px;"
              :src="ali_pay"
              fit="fit" />
          </el-form-item>
          <el-form-item>
            <p class="red">支付宝扫码后,请点击立即充值</p>
          </el-form-item>
        </div>-->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="topUpStatus = false">取消转账</el-button>
        <el-button type="primary" class="button_blue_color" @click="onRecharge" :disabled="disabledR"
          >我已转账 申请充值</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      title="修改提现密码"
      :visible.sync="withdrawalState"
      width="25%"
      :close-on-click-modal="false"
    >
      <el-form>
        <el-form-item>
          <el-row>
            <el-col :span="14">
              <el-input
                v-model="payRePicCode"
                placeholder="请输入图形验证码"
              ></el-input>
            </el-col>
            <el-col :span="10">
              <img
                :src="captcha"
                style="width: 100%"
                @click="this.getCaptcha"
              />
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item>
          <el-row>
            <el-col :span="14">
              <el-input
                v-model="inputPayCode"
                autocomplete="off"
                placeholder="请输入验证码"
              ></el-input>
            </el-col>
            <el-col :span="10">
              <el-button
                :disabled="disabled3"
                type="info"
                style="width: 100%"
                @click="getPayCode"
                >{{ getPayCodeText }}
              </el-button>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item>
          <el-input
            type="password"
            v-model="inputPayPass"
            placeholder="请输入密码"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            type="password"
            v-model="inputPayConf"
            placeholder="请输入确认密码"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="emptyPayPass">取 消</el-button>
        <el-button type="primary" class="button_blue_color" @click="setPayPass">确 定</el-button>
      </div>
    </el-dialog>

    <!-- <el-dialog
      :visible.sync="Recharge_amount"
      width="25%"
      :close-on-click-modal="true"
      id="thirdPartyPopup"
    >
      <el-form :model="real" style="text-align: center">
        <span style="font-size: 18px; margin-bottom: 1px">{{
          Recharge_Max
        }}</span>
      </el-form>

      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button
          style="border: 1px solid grey"
          @click="Recharge_amount = false"
          >取消</el-button
        >
      </div>
    </el-dialog> -->

    <!--    实名认证-->
    <el-dialog
      title="实名认证"
      :visible.sync="real.realStatus"
      width="25%"
      :close-on-click-modal="false"
    >
      <el-form :model="real">
        <el-form-item>
          <el-input
            placeholder="请输入真实姓名"
            v-model="real.inputReal"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            placeholder="请输入身份证号"
            v-model="real.inputIdcard"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="real.realStatus = false">取 消</el-button>
        <el-button type="primary" class="button_blue_color" @click="setReal">确 定</el-button>
      </div>
    </el-dialog>

    <!--    绑定银行卡-->
    <el-dialog
      title="绑定银行卡"
      :visible.sync="bank.bankStatus"
      width="25%"
      :close-on-click-modal="false"
    >
      <el-form :model="bank">
        <el-form-item>
          <el-select v-model="bank.bankId" style="width: 100%">
            <el-option
              v-for="(item, index) in bank.bankList"
              :key="index"
              :value="item.id"
              :label="item.bank"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input
            placeholder="请输入银行卡号"
            v-model="bank.inputBankCode"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            placeholder="请输入开户人姓名"
            v-model="bank.inputBankName"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            placeholder="请输入开户行支行"
            v-model="bank.inputBankAccess"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="bank.bankStatus = false">取 消</el-button>
        <el-button type="primary" class="button_blue_color" @click="setBank">确 定</el-button>
      </div>
    </el-dialog>
    <!--recharget type 21---->
    <el-dialog
      title="易云汇支付"
      :close-on-click-modal="false"
      :visible.sync="yiyunhuiPopup"
      width="800px"
    >
      <div>
        <div class="notice-hint">
          <div style="width: 670px; text-align: left" class="hint" slot="label">
            <div id="qrcode_recharge"></div>
          </div>
          <el-row>
            <el-col :span="14">
              易云汇支付 充值地址：<br />
              {{ yiyunpay.link }}
            </el-col>
            <el-col :span="10">
              <el-button
                type="text"
                class="right button_blue_color"
                @click="handleCopy(yiyunpay.link)"
                >复制</el-button
              >
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="20"> &nbsp; </el-col>
            <el-col :span="4">
              <div style="margin-bottom:20px;">
                <el-button type="primary" class="button_blue_color" @click="completeRecharge()"
                  >我转了钱</el-button
                >
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-dialog>
    <!--withdraw popup-->
     <el-dialog
    :visible.sync="withdrawSecondPopup"
    width="450px"
    center
  >
    <div style="text-align:center;" v-html="withdraw_popup_content">
    </div>

    <span slot="footer" class="dialog-footer">
       <div class="dialog-footer-left" style="justify-content: right !important;">
      <el-button @click="cancelRedirection()" style="padding:9px 15px !important;font-size: 12px;;">{{ left_side_button_name }}</el-button>
      <el-button type="primary" :disabled="withdrawDisabled"  @click="withdrawal()" style="padding:9px 15px !important;font-size: 12px;;">{{ right_side_button_name }}</el-button>
    </div>
    </span>
  </el-dialog>
    <!--end-->
     <!--    user withdraw address set-->
    <el-dialog title="绑定 WPay" custom-class="wpay-bind-dialog" :visible.sync="wpayBindVisible" width="460px" :close-on-click-modal="false">
      <div class="wpay-bind-body">
        <p class="wpay-bind-tip">提现前请先绑定 WPay 账户。绑定会在新标签页打开，完成后回到本页继续提现。</p>
        <div v-if="wpayDescription" class="wpay-bind-desc" v-html="wpayDescription"></div>
        <div class="wpay-bind-action">
          <el-button type="danger" class="button_red_color" :loading="wpayLinking" @click="startWpayLink">绑定 WPay</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="提款地址"
      :visible.sync="usdt.userWithdrawAddressPopup"
      width="25%"
      :close-on-click-modal="false"
    >
      <el-form>
      <el-row>
            <el-col :span="14">
              <el-input
                v-model="usdt.captcha"
                placeholder="请输入图形验证码"
              ></el-input>
            </el-col>
            <el-col :span="10">
              <img
                :src="captcha"
                style="width: 100%"
                @click="this.getCaptcha"
              />
            </el-col>
          </el-row>
        <el-form-item>
          <el-input
            placeholder="请输入开户人姓名"
            v-model="usdt.input_user_withdraw_address"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="usdt.userWithdrawAddressPopup = false">取 消</el-button>
        <el-button type="primary" class="button_blue_color" @click="setUserWithdrawAddress">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import $ from "jquery";
import QRCode from "qrcodejs2";
import JSEncrypt from "jsencrypt/bin/jsencrypt";
import { version } from "../../package";

export default {
  name: "capital",
  data() {
    return {
      selectedTypeId: "",
      selectedWithdrawTypeId: "",
      notice_1_1: "",
      notice_2_1: "",
      notice_2_2: "",
      notice_1_10:"",
      cryptoUrl: "",
      version: version,
      //充值用户信息
      recharge: {
        number: "",
        type: "6",
        card: "",
        //实名状态
        realStatus: false,
        url: "",
        recharge_content: ""
      },
      radio: 0,
      radioW: 0,
      real: {
        inputReal: "",
        inputIdcard: "",
        realStatus: false
      },
      //提现用户信息
      withdrawalData: {
        name: "",
        card: "",
        address: "",
        account: "",
        money: "",
        password: "",
        cash: 0,
        bankStatus: false,
        isWithdrawalData: false,
        type: 1,
        id: 1,
        gxpay_id: "",
        checked: false
      },
      rechargeType: [],
      rechargeTypeAll: [],
      rechargeMethodOptions: [],
      rechargeSourceOptions: [],
      isRechargeMethodShow: 0,
      isRechargeChannelShow: 0,
      userFlagsReady: false,
      rechargeTypesReady: false,
      selectedMethod: null,
      rechargeChoiceId: "",
      rechargeDefaultApplied: false,
      selectedChannel: null,
      methodSectionHidden: false,
      channelSectionHidden: false,
      withdraweType: [],
      //银行卡
      bank: {
        bankId: "",
        inputBankCode: "",
        inputBankName: "",
        inputBankAccess: "",
        bankList: [],
        bankStatus: false
      },

      recharge_rules: {
        money: [
          { required: true, message: "请输入充值金额", trigger: "blur" },
          {
            integer: "integer",
            min: 1,
            max: 9999999,
            message: "请输入正确金额",
            trigger: "blur"
          }
        ]
      },
      companyBank: {},
      //用户银行卡
      bankCardList: [],
      //银行卡管理状态
      bankCardState: false,
      ali_isactive: 0,
      wechat_isactive: 0,
      ali_pay: "",
      we_chat_pay: "",
      topUpStatus: false,
      data: "",
      withdrawalState: false,
      inputPayCode: "",
      getPayCodeText: "获取验证码", //
      inputPayPass: "", //支付密码
      inputPayConf: "", //确认密码
      inputLoginPhone: "", //获取手机号
      disabled3: false,
      disabled4: false,
      disabledR: false,
      maxCouponData: "",
      maxCouponCheck: false,
      coupounAmount: "",
      effectiveDate: "",
      time: {
        endTime: 0
      },
      activeName: "recharge",
      // Recharge_amount: false,
      Recharge_Max: "",
      crypto: {
        money: 0,
        USDTAmount: "",
        qrCode: "",
        endTime: 0,
        rechargeId: 0
      },
      countDownTime: 1800,
      interVal: "",
      popupStatus: 0,
      timbaoAnulaizedInterestRate: 0,
      timebaoRate: 0,
      trade_channel_status: "",
      showTradeChannelPopup: false,
      trade_rules_content_top: "",
      trade_rules_content_bottom: "",
      withdraw_fee_percentage: 0,
      withdraw_fee_min: 0,
      payRePicCode: "",
      captcha: "",
      verify_token: "",
      auto_fill_amounts: [],
      button_text:"",
      isAutoAmounts: false,
      yiyunpay: {
        qrcode_recharge: "",
        link: ""
      },
      yiyunhuiPopup: false,

      auto_fill_amounts_withdraw: [],
      isAutoAmountsWithdraw: false,
      selected_type: "",
      wpayLinked: false,
      wpayBindVisible: false,
      wpayDescription: "",
      wpayLinking: false,
      alipayInfo: {},
      withdrawable_amount:0,
      is_non_withdrawable:false,
      withdraw_popup_content:"",
      withdrawSecondPopup:false,
      right_side_button_name:"",
      pc_left_side_redirection:"",
      left_side_button_name:"",
      usdt:{
        user_withdraw_address:"",
        userWithdrawAddressPopup:false,
        input_user_withdraw_address:"",
        usdt_amount:0,
        exchange_rate:0,
        captcha:"",
      },
      withdrawDisabled:false,

    };
  },
  computed: {
    rechargeFilterMode() {
      return this.isRechargeMethodShow == 1 || this.isRechargeChannelShow == 1;
    },
    rechargeListReady() {
      return this.userFlagsReady && this.rechargeTypesReady;
    }
  },
  watch: {
  "recharge.number"() {
    if (this.rechargeFilterMode && this.rechargeListReady) {
      this.applyRechargeFilters();
    }
  },
  'withdrawalData.money'(val) {
    let that=this;
    val = val.replace(/\D/g, '')
    if (val.length === 1) {
      val = val.replace(/[^1-9]/g, '')
    }

    that.withdrawalData.money = val

    if (val) {
  if(that.usdt.exchange_rate>0){
     let usdt_amount = document.getElementById("usdt_amount");
    usdt_amount.innerHTML=(that.withdrawalData.money/that.usdt.exchange_rate).toFixed(2);
     }
    } else {
       usdt_amount.innerHTML = 0;
    }
  }
},
  methods: {
    cancelRedirection(){
      this.$router.push(this.pc_left_side_redirection);
    },
    showPopup(){
      this
          .$confirm(
            "任何充值都必须配资后买入才可提现。买入额为充值额的10倍即可全额提现。",
            {
              title: "友情提醒",
              confirmButtonText: "继续提现",
              showCancelButton: false
            }
          )
    },
    getCaptcha() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "getSmsPic",
            version: that.version
          }
        })
        .then(function(res) {
          let resData = res.data;
          if (resData.code == 1) {
            that.captcha =localStorage.getItem("lineUrl") + resData.data.code_url;
            that.verify_token = resData.data.verify_token;
          } else if (resData.code == 0) {
            that.disabled = false;
            that.$message.error(res.data.msg);
          }
        });
    },

    //充值活动
    getData() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "protocol",
            type: 19
          }
        })
        .then(res => {
          let resData = res.data;
          if (res.data.code == 1) {
            that.data = resData.data;
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(res.data.msg);
          }
        });
    },
    macCoupon() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "max_coupon",
            token: sessionStorage.getItem("token")
          }
        })
        .then(res => {
          let resData = res.data;
          if (res.data.code == 1) {
            that.maxCouponData = resData.data;
            if (that.maxCouponData.length === 0) {
              that.maxCouponCheck = false;
            } else {
              that.maxCouponCheck = true;
            }

            that.coupounAmount = that.maxCouponData.amount;
            that.effectiveDate = that.maxCouponData.effect_date;
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(res.data.msg);
          }
        });
    },
    //下一步
    rechargeNext() {
      let that = this;
      if (
        that.selectedTypeId === "" ||
        that.selectedTypeId === null ||
        typeof that.selectedTypeId === "undefined"
      ) {
        that.$message.error("请选择充值类型");
        return;
      }
      let number = parseInt(that.recharge.number);
      let type = that.recharge.type;
      if (number === "" || isNaN(number) || number < 100) {
        this.$message.error("请填写正确金额");
      } else if (
        type == 6 ||
        type == 7 ||
        type == 8 ||
        type == 9 ||
        type == 12
      ) {
        that.disabled4 = true;
        that
          .$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "recharge_max_amount",
              token: sessionStorage.getItem("token"),
              type: that.recharge.type,
              recharge_id: that.selectedTypeId
            }
          })
          .then(function(res) {
            if (res.data.code == 1) {
              that.disabled4 = false;
              let maxamountList = res.data.data;
              if (Object.keys(maxamountList).length > 0) {
                if (number > res.data.data.amount) {
                  // (that.Recharge_amount = true),
                  //   (that.Recharge_Max = res.data.data.message);
                  that.$message.warning(res.data.data.message);
                } else {
                  that.recharge_has(number);
                }
              } else {
                that.recharge_has(number);
              }
            } else if (res.data.code == 0 || res.data.code == -1) {
              that.disabled4 = false;
              that.$message.error(res.data.msg);
            } else {
              that.disabled4 = false;
              that.$message.error(res.data.msg);
            }
          })
          .catch(() => {
            that.disabled4 = false;
          });
      } else {
        that.recharge_has(number);
      }
    },
    //设置实名认证
    setReal() {
      let that = this;
      if (that.real.inputReal == "") {
        that.$message.error("请输入真实姓名");
      } else if (that.real.inputIdcard == "") {
        that.$message.error("请输入身份证号");
      } else {
        that
          .$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "certification",
              token: sessionStorage.getItem("token"),
              name: that.real.inputReal,
              card: that.real.inputIdcard
            }
          })
          .then(function(res) {
            if (res.data.code == 1) {
              that.$message({
                message: res.data.msg,
                type: "success",
                duration: 1000,
                onClose: function() {
                  that.real.realStatus = false;
                  that.recharge.realStatus = true;
                }
              });
            } else if (res.data.code == 0 || res.data.code == -1) {
              that.$message.error(res.data.msg);
            }
          });
      }
    },
    //设置银行卡
    setBank() {
      let that = this;
      if (that.bank.inputBankCode == "") {
        that.$message.error("请输入银行卡号");
      } else if (that.bank.inputBankName == "") {
        that.$message.error("请输入开户人姓名");
      } else if (that.bank.inputBankAccess == "") {
        that.$message.error("请输入开户行地址");
      } else {
        that
          .$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "bind_bank",
              token: sessionStorage.getItem("token"),
              name: that.bank.inputBankName,
              bank_id: that.bank.bankId,
              address: that.bank.inputBankAccess,
              card: that.bank.inputBankCode
            }
          })
          .then(function(res) {
            if (res.data.code == 1) {
              that.$message({
                message: res.data.msg,
                type: "success",
                duration: 1000,
                onClose: function() {
                  that.bank.bankStatus = false;
                  that.withdrawalData.bankStatus = true;
                  that.getAccountBank();
                }
              });
            } else if (res.data.code == 0 || res.data.code == -1) {
              that.$message.error(res.data.msg);
            }
          });
      }
    },
     //设置银行卡
    setUserWithdrawAddress() {
      let that = this;
      if (that.usdt.input_user_withdraw_address == "") {
        that.$message.error("请输入开户行地址");
      } else {
        that
          .$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "modify_withdraw_address",
              token: sessionStorage.getItem("token"),
              withdrawAdd: that.usdt.input_user_withdraw_address.trim(),
              rePicCode: that.usdt.captcha,
              verify_token: that.verify_token,
            }
          })
          .then(function(res) {
            if (res.data.code == 1) {
              that.$message({
                message: res.data.msg,
                type: "success",
                duration: 1000,
                onClose: function() {
                  that.usdt.userWithdrawAddressPopup = false;
                  that.getUserWithdrawAddress();
                }
              });
            } else if (res.data.code == 0 || res.data.code == -1) {
              that.$message.error(res.data.msg);
            }
          });
      }
    },
    recharge_has(number) {
      let that = this;
      that.disabled4 = true;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "recharge_has",
            token: sessionStorage.getItem("token"),
            number: number
          }
        })
        .then(function(res) {
          that.disabled4 = false;
          let resData = res.data;
          if (resData.code == 0) {
            that.topUpTransit(number);
          } else {
            that
              .$confirm(
                "您有一笔相同金额的充值成功或失败未能确定，请联系客服，或请使用其他金额充值。",
                {
                  showConfirmButton: false,
                  confirmButtonText: " ",
                  cancelButtonText: "确定",
                  type: "warning",
                  cancelButtonClass: "cancel"
                }
              )
              .then(() => {
                that.topUpTransit(number);
              })
              .catch(() => {});
          }
        })
        .catch(() => {
          that.disabled4 = false;
        });
    },
    topUpTransit(number) {
      let that = this;
      if (that.recharge.realStatus) {
        let type = parseInt(that.recharge.type);
        let SelectedType =
          that.rechargeType.find(o => o.id == that.selectedTypeId) ||
          that.rechargeTypeAll.find(o => o.id == that.selectedTypeId);
        that.notice_1_1 = SelectedType.notice_1_1;
        that.notice_2_1 = SelectedType.notice_2_1;
        that.notice_2_2 = SelectedType.notice_2_2;
        switch (type) {
          case 6:
            that.disabled4 = true;
            this.$message("正在打开支付通道");
            that
              .$http({
                url: "/",
                method: "post",
                data: {
                  nozzle: "offline_recharge",
                  token: sessionStorage.getItem("token"),
                  number: number,
                  type: type,
                  card: "",
                  recharge_id: that.selectedTypeId
                }
              })
              .then(function(res) {
                if (res.data.code == 1) {
                  let resData = res.data.data;
                  that.topUpStatus = true;
                  that.disabled4 = false;

                  that.companyBank.money = resData.receiveOrderAmount;
                  that.companyBank.name = resData.receiveBankAccountName;
                  that.companyBank.card = resData.receiveBankAccountNo;
                  that.companyBank.bank = resData.receiveBankName;
                  let endTime = Number(that.$moment().format("x"));
                  endTime = endTime + 10 * 60 * 1000;
                  that.time.endTime = that
                    .$moment(endTime)
                    .format("YYYY-MM-DD HH:mm:ss");
                } else if (res.data.code == 2) {
                  that.getTradeChannel();
                  that.disabled4 = false;
                } else if (res.data.code == 0 || res.data.code == -1) {
                  that.$message.error(res.data.msg);
                  that.disabled4 = false;
                }
              })
              .catch(() => {
                that.disabled4 = false;
              });
            break;
          case 7:
            that.disabled4 = true;
            this.$message("正在打开支付通道");
            that
              .$http({
                url: "/",
                method: "post",
                data: {
                  nozzle: "offline_recharge",
                  token: sessionStorage.getItem("token"),
                  number: number,
                  type: type,
                  card: "",
                  recharge_id: that.selectedTypeId
                }
              })
              .then(function(res) {
                if (res.data.code == 1) {
                  let resData = res.data;
                  that.recharge.url = resData.data.url;
                  that.topUpStatus = true;
                  that.disabled4 = false;
                } else if (res.data.code == 2) {
                  that.getTradeChannel();
                  that.disabled4 = false;
                } else if (res.data.code == 0 || res.data.code == -1) {
                  that.$message.error(res.data.msg);
                  that.disabled4 = false;
                }
              })
              .catch(() => {
                that.disabled4 = false;
              });
            break;
          case 8:
            that.disabled4 = true;
            this.$message("正在打开支付通道");
            that
              .$http({
                url: "/",
                method: "post",
                data: {
                  nozzle: "offline_recharge",
                  token: sessionStorage.getItem("token"),
                  number: number,
                  type: type,
                  card: "",
                  recharge_id: that.selectedTypeId
                }
              })
              .then(function(res) {
                if (res.data.code == 1) {
                  let resData = res.data;
                  that.recharge.url = resData.data.url;
                  that.topUpStatus = true;
                  that.disabled4 = false;
                } else if (res.data.code == 2) {
                  that.getTradeChannel();
                  that.disabled4 = false;
                } else if (res.data.code == 0 || res.data.code == -1) {
                  that.$message.error(res.data.msg);
                  that.disabled4 = false;
                }
              })
              .catch(() => {
                that.disabled4 = false;
              });
            break;
          case 9:
          case 10:
          case 11:
          case 13:
          case 14:
          case 17:
          case 18:
          case 19:
          case 22:
          case 23:
          case 24:
          case 25:
          case 26:
          case 28:
          case 29:
          case 30:
          case 31:
          case 32:
          case 33:
          case 34:
          case 35:
            that.disabled4 = true;
            this.$message("正在打开支付通道");
            that
              .$http({
                url: "/",
                method: "post",
                data: {
                  nozzle: "offline_recharge",
                  token: sessionStorage.getItem("token"),
                  number: number,
                  type: type,
                  card: "",
                  recharge_id: that.selectedTypeId
                }
              })
              .then(function(res) {
                if (res.data.code == 1) {
                  let resData = res.data;
                  window.open(resData.data.url);
                  that
                    .$confirm("请确认您已付款！重复提交会影响到账时间", {
                      confirmButtonText: "确定",
                      cancelButtonText: "取消",
                      type: "warning"
                    })
                    .then(() => {
                      // that.$router.push('/myaccount/detailed');
                      //on confirm show success message
                      that.$message({
                        message: "充值申请成功,尽快完成后续操作,联系客服吧",
                        type: "success",
                        onClose: function() {
                          that.topUpStatus = false;
                          that.$router.push("/myaccount/account_info?active_tab=bill");
                        }
                      });
                    })
                    .catch(() => {});
                  that.disabled4 = false;

                  // that.recharge.url = resData.data.url;

                  // that.topUpStatus = true;
                  // that.disabled4 = false;
                  // window.location.href = resData.data.url;
                } else if (res.data.code == 2) {
                  that.getTradeChannel();
                  that.disabled4 = false;
                } else if (res.data.code == 0 || res.data.code == -1) {
                  that.$message.error(res.data.msg);
                  that.disabled4 = false;
                }
              })
              .catch(() => {
                that.disabled4 = false;
              });
            break;
          case 12:
            that.disabled4 = true;
            this.$message("正在打开支付通道");
            that
              .$http({
                url: "/",
                method: "post",
                data: {
                  nozzle: "offline_recharge",
                  token: sessionStorage.getItem("token"),
                  number: number,
                  type: type,
                  recharge_id: that.selectedTypeId
                }
              })
              .then(function(res) {
                if (res.data.code == 1) {
                  let resData = res.data.data;
                  that.topUpStatus = true;
                  that.disabled4 = false;
                  that.crypto.money = resData.orderAmount;
                  that.crypto.USDTAmount = resData.orderUSDTAmount;
                  that.crypto.qrCode = resData.qrCodeGenerator;
                  that.crypto.rechargeId = resData.recharge_id;
                  that.qrcode(that.crypto.qrCode);
                  that.CountDown();
                } else if (res.data.code == 2) {
                  that.getTradeChannel();
                  that.disabled4 = false;
                } else if (res.data.code == 0 || res.data.code == -1) {
                  that.$message.error(res.data.msg);
                  that.disabled4 = false;
                }
              })
              .catch(() => {
                that.disabled4 = false;
              });
            break;
          case 20:
            that.disabled4 = false;
            that.topUpStatus = true;
            break;
          case 21:
            that.disabled4 = true;
            this.$message("正在打开支付通道");
            that
              .$http({
                url: "/",
                method: "post",
                data: {
                  nozzle: "offline_recharge",
                  token: sessionStorage.getItem("token"),
                  number: number,
                  type: type,
                  recharge_id: that.selectedTypeId
                }
              })
              .then(function(res) {
                if (res.data.code == 1) {
                  let resData = res.data.data;
                  that.yiyunhuiPopup = true;
                  that.disabled4 = false;
                  that.yiyunpay.qrcode_recharge = resData.url;
                  that.yiyunpay.link = resData.url;
                  that.qrcode_yiyunhui(that.yiyunpay.qrcode_recharge);
                } else if (res.data.code == 0 || res.data.code == -1) {
                  that.$message.error(res.data.msg);
                  that.disabled4 = false;
                }
              })
              .catch(() => {
                that.disabled4 = false;
              });
            break;
            case 27:
            that.getCompanyBank();
            that.disabled4 = false;
            that.topUpStatus = true;
            break;
          default:
            that.getCompanyBank();
            break;
        }
      } else {
        that.real.realStatus = true;
      }
    },
    completeRecharge() {
      this.yiyunhuiPopup = false;
      this.$router.push("/myaccount/account_info?active_tab=bill");
    },
    bankFadeIn() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "bank_info",
            token: sessionStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code == 1) {
            that.bank.bankList = res.data.data.bank;
            that.bank.bankId = that.bank.bankList[0].id;
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(res.data.msg);
          }
        });
    },
    //获取验证码
    getPayCode() {
      let that = this;
      that.disabled3 = true;
      clearInterval(window.timer2);

      let publicKey = localStorage.getItem("encript_public_key");
      let userPhone = that.inputLoginPhone.toString();
      let inputPhone = that.encryptMessage(userPhone, publicKey);

      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "modifyInfo_code_e",
            info: inputPhone,
            type: 1,
            rePicCode: that.payRePicCode,
            verify_token: that.verify_token,
            token: sessionStorage.getItem("token"),
            
          }
        })
        .then(function(res) {
          if (res.data.code == 1) {
            that.$message({
              message: res.data.msg,
              type: "success",
              duration: 2000
            });
            var time = 60;
            that.getPayCodeText = time + "s";
            window.timer2 = setInterval(function() {
              time--;
              that.getPayCodeText = time + "s";
              if (time <= 0) {
                clearInterval(window.timer2);
                that.disabled3 = false;
                that.getPayCodeText = "获取验证码";
              }
            }, 1000);
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(res.data.msg);
            that.disabled3 = false;
          }
        });
    },
    encryptMessage(message, publicKey) {
      const jsEncrypt = new JSEncrypt();
      jsEncrypt.setPublicKey(publicKey);
      return jsEncrypt.encrypt(message);
    },
    //修改登录密码 操作
    setPayPass() {
      let that = this;
      if (that.inputPayCode == "") {
        that.$message.error("请输入验证码");
      } else if (that.inputPayPass == "") {
        that.$message.error("请输入密码");
      } else if (that.inputPayConf == "") {
        that.$message.error("请输入确认密码");
      } else if (that.inputPayConf != that.inputPayPass) {
        that.$message.error("两次密码输入不一致");
      } else {
        let publicKey = localStorage.getItem("encript_public_key");
        let inputPassWord = that.encryptMessage(that.inputPayPass, publicKey);
        let inputPassWordCon = that.encryptMessage(
          that.inputPayConf,
          publicKey
        );
        that
          .$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "modify_pay_e",
              token: sessionStorage.getItem("token"),
              password: inputPassWord,
              confirm: inputPassWordCon,
              code: that.inputPayCode
            }
          })
          .then(function(res) {
            if (res.data.code == 1) {
              that.$message({
                message: res.data.msg,
                type: "success",
                duration: 1000,
                onClose: function() {
                  that.withdrawalState = false;
                }
              });
              that.payRePicCode = "";
              that.inputPayCode = "";
              that.inputPayPass = "";
              that.inputPayConf = "";
            } else if (res.data.code == 0 || res.data.code == -1) {
              that.$message.error(res.data.msg);
            }
          });
      }
    },
    //取消支付密码
    emptyPayPass() {
      let that = this;
      that.payRePicCode = "";
      that.inputPayCode = "";
      that.inputPayConf = "";
      that.inputPayPass = "";
      that.withdrawalState = false;
    },
    //充值
    onRecharge() {
      let that = this;
      that.recharge.url = "";
      let number = parseInt(that.recharge.number);
      let type = parseInt(that.recharge.type);
      if (number === "" || isNaN(number)) {
        this.$message.error("请填写正确金额");
      }
      // let card = that.recharge.card.toString();
      if (type === "" || isNaN(type)) {
        this.$message.error("请选择充值方式");
      } else if (type === 6 || type === 7 || type === 8) {
        that.$message({
          message: "充值申请成功,尽快完成后续操作,联系客服吧",
          type: "success",
          onClose: function() {
            that.topUpStatus = false;
            that.$router.push("/myaccount/account_info?active_tab=bill");
            that.time.endTime = 0;
          }
        });
      } else if (type === 12) {
        that.disabledR = true;
        that
          .$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "recharge_sure",
              token: sessionStorage.getItem("token"),
              id: that.crypto.rechargeId
            }
          })
          .then(function(res) {
            if (res.data.code == 1) {
              that.$message({
                message: res.data.msg,
                type: "success",
                onClose: function() {
                  that.topUpStatus = false;
                  that.$router.push("/myaccount/account_info?active_tab=bill");
                  that.disabledR = false;
                }
              });
            } else if (res.data.code == 2) {
              that.getTradeChannel();
              that.disabledR = false;
            } else if (res.data.code == 0 || res.data.code == -1) {
              that.$message.error(res.data.msg);
              that.disabledR = false;
            }
          });
      } else {
        that.disabledR = true;
        that
          .$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "offline_recharge",
              token: sessionStorage.getItem("token"),
              number: number,
              type: type,
              card: type==27?that.alipayInfo.alipay_account:that.companyBank.card,
              recharge_id: that.selectedTypeId
            }
          })
          .then(function(res) {
            if (res.data.code == 1) {
              that.$message({
                message: res.data.msg,
                type: "success",
                onClose: function() {
                  that.topUpStatus = false;
                  that.$router.push("/myaccount/account_info?active_tab=bill");
                  that.disabledR = false;
                }
              });
            } else if (res.data.code == 2) {
              that.getTradeChannel();
              that.disabledR = false;
            } else if (res.data.code == 0 || res.data.code == -1) {
              that.$message.error(res.data.msg);
              that.disabledR = false;
            }
          })
          .catch(() => {
            that.disabledR = false;
          });
      }
    },
    //获取公司银行卡
    getCompanyBank() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "offline_info",
            token: sessionStorage.getItem("token"),
            number: parseInt(that.recharge.number)
          }
        })
        .then(function(res) {
          let resData = res.data.data;
          if (res.data.code == 1) {
            if (that.recharge.type == 8) {
              that.companyBank.card = "联系在线客服";
            } else {
              that.companyBank = res.data.data.bank;
            }
            if(that.recharge.type == 27){
              that.alipayInfo=res.data.data.alipay;
            }

            /*that.ali_isactive = Number(resData.ali_isactive);
            that.wechat_isactive = Number(resData.ali_isactive);
            if (that.ali_isactive === 1){
              that.ali_pay = resData.ali_pay;
            }
            if (that.wechat_isactive){
              that.we_chat_pay = resData.we_chat_pay;
            }*/

            that.$message({
              message: "正在打开支付通道",
              duration: 500,
              onClose: function() {
                that.topUpStatus = true;
              }
            });
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(res.data.msg);
          } else {
            that.$message.error(res.data.msg);
          }
        });
    },
    //复制
    handleCopy(copy) {
      let that = this;
      let typeName = copy;
      let oInput = document.createElement("input");
      oInput.value = typeName;
      document.body.appendChild(oInput);
      oInput.select();
      document.execCommand("Copy");
      this.$message({
        message: "复制成功",
        type: "success"
      });
      oInput.remove();
    },
    //获取账户银行卡
    getAccountBank() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "accountbank",
            token: sessionStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code == 1) {
            that.bankCardList = res.data.data;
            if (that.bankCardList.length > 0) {
              that.withdrawalData.account = that.bankCardList[0].account;
              that.withdrawalData.card = that.bankCardList[0].card;
              that.withdrawalData.name = that.bankCardList[0].name;
              that.withdrawalData.address = that.bankCardList[0].address;
              that.withdrawalData.isWithdrawalData = true; //if bank information have, set showbandcard popup not to show
            } else {
              that.withdrawalData.isWithdrawalData = false; //if bank information have, set showbandcard popup to show
            }
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(res.data.msg);
          }
        })
        .finally(() => {
          that.showBankCardPopup();
        });
    },
    loadWpayLink(){
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "wpay_info",
            token: sessionStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code == 1) {
            that.wpayLinked = res.data.data.linked == 1;
            that.wpayDescription = res.data.data.description || "";
          }
        });
    },
    startWpayLink() {
      let that = this;
      const tab = window.open("about:blank", "_blank");
      that.wpayLinking = true;
      const returnUrl = window.location.origin + "/#/myaccount/wpay";
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "wpay_link_start",
            token: sessionStorage.getItem("token"),
            return_url: returnUrl
          }
        })
        .then(function(res) {
          that.wpayLinking = false;
          if (res.data.code == 1 && res.data.data.authorize_url) {
            if (tab) {
              tab.location.href = res.data.data.authorize_url;
            } else {
              window.open(res.data.data.authorize_url, "_blank");
            }
            window.location.reload();
          } else {
            if (tab) tab.close();
            that.$message.error(res.data.msg || "绑定失败");
          }
        })
        .catch(function() {
          that.wpayLinking = false;
          if (tab) tab.close();
        });
    },
    getUserWithdrawAddress(){
       let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "user",
            token: sessionStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code == 1) {
            that.usdt.user_withdraw_address=res.data.data.withdraw_address;
            if(res.data.data.withdraw_address==""){
              that.showWithdrawAddressPopup();
            }
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(res.data.msg);
          }
        });
    },
    handleClick(tab, event) {
      let that = this;
      switch (tab.name) {
        case "withdraw":
          //get withdraw bank information everytime come to withdraw tab
          if(that.selected_type==3){
            that.getUserWithdrawAddress();
          }
          else if(that.selected_type==4){
            that.loadWpayLink();
          }
          else{
          that.getAccountBank();
          }

          // if (that.withdrawalData.isWithdrawalData) {
          // that
          //   .$confirm("请先设置提现银行卡才能提现", "提示", {
          //     confirmButtonText: "确定",
          //     cancelButtonText: "取消",
          //     type: "warning",
          //   })
          //   .then(() => {
          //     that.bank.bankStatus = true;
          //   })
          //   .catch(() => {
          //     this.$message({
          //       type: "info",
          //       message: "已取消删除",
          //     });
          //   });
          // }
          break;
      }
    },
    //多银行卡选择
    handleBankCard(row) {
      let that = this;
      that.withdrawalData.account = row.account;
      that.withdrawalData.card = row.card;
      that.withdrawalData.name = row.name;
      that.withdrawalData.address = row.address;
      that.bankCardState = false;
    },
    //获取用户信息
    getUserinfo() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "user",
            token: sessionStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code == 1) {
            that.withdrawalData.cash = res.data.data.cash;
            that.withdrawable_amount=res.data.data.withdrawable_amount;
            that.is_non_withdrawable=res.data.data.is_non_withdrawable;
            that.trade_channel_status = res.data.data.trade_channel_status;
            that.isRechargeMethodShow = res.data.data.is_recharge_method_show;
            that.isRechargeChannelShow = res.data.data.is_recharge_channel_show;
            that.userFlagsReady = true;
            that.applyRechargeFilters();
            if (that.trade_channel_status == 1) {
              that.getTradeChannel();
            }
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(res.data.msg);
          }
        });
    },
    // get withdraw free precentage
    getWithdrawChannelInfo() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "withdraw_channel",
            token: sessionStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code == 1) {
            that.withdraw_fee_percentage =
              res.data.data.withdraw_fee_percentage;
            that.withdraw_fee_min = res.data.data.withdraw_fee_min;
          } else if (res.data.code == 0 || res.data.code == -1) {
            // that.$message.error(res.data.msg);
          }
        });
    },

    withdraw_has() {
      let that = this;
      let type = parseInt(that.withdrawalData.type);
      if (type == 4 && !that.wpayLinked) {
        that.wpayBindVisible = true;
        that.loadWpayLink();
        return;
      }
      let number = that.withdrawalData.money;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "withdraw_has",
            token: sessionStorage.getItem("token"),
            number: number
          }
        })
        .then(function(res) {
          let resData = res.data;
          if (resData.code == 0) {
            that.WithdrawPopup();
            // that.withdrawal();
            // that.topUpTransit(number);
          } else {
            that
              .$confirm(
                "\n" +
                  "您已提交一笔同金额的提现正在审核处理中\n若非新提现请勿重复提交",
                "提示",
                {
                  confirmButtonText: "继续新提现",
                  cancelButtonText: "非新提现"
                }
              )
              .then(() => {
                that.WithdrawPopup();
                // that.topUpTransit(number);
              })
              .catch(() => {});
          }
        });
    },
    WithdrawPopup() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "sysconfig",
            action: "withdraw_popup"
          }
        })
        .then(function(res) {
          if (res.data.code == 1) {
            that.popupStatus = res.data.data.is_withdraw_popup;
            that.timbaoAnulaizedInterestRate =
              res.data.data.timebao_annualized_interest_rate;
            that.timebaoRate = res.data.data.timebao_rate;
            that.withdraw_popup_content=res.data.data.withdraw_popup_content;
            that.left_side_button_name=res.data.data.left_side_button_name;
            that.right_side_button_name=res.data.data.right_side_button_name;
            that.pc_left_side_redirection=res.data.data.pc_left_side_redirection;
            that.secondWithdrawalPopup();
          } else if (res.data.code == 0) {
            that.$message.error(res.data.msg);
          }
        });
    },
    secondWithdrawalPopup() {
  let that = this;
  if (that.popupStatus == 1) {
    that.withdrawSecondPopup=true;

//     that.$confirm(
//  `
//       <div style="text-align:center;">
//         <p style="
//           display:inline-block;
//           text-align:left;
//           margin:0;
//           line-height:1.6;
//         ">
//           1 买入2日基金，1万元起，收益0.24%.<br>
//           2 基金转出后配资，交易额10倍，收益2%
//         </p>
//       </div>
//       `,
//       "稳定币基金大额奖 ，2天收益2%+",
//       {
//         confirmButtonText: "继续提现",
//         cancelButtonText: "转入稳定币基金",
//         dangerouslyUseHTMLString: true
//       }
//     )
//     .then(() => {
//       that.withdrawal();
//     })
//     .catch(() => {
//       that.$router.push("/myaccount/stable_coinbao");
//     });
  } 
  else {
    that.withdrawal();
  }
},
    //提现
    withdrawal() {
      let that = this;
      that.withdrawDisabled = true;
      let number = that.withdrawalData.money;
      let password = that.withdrawalData.password;
      let name = that.withdrawalData.name;
      let card = that.withdrawalData.card;
      let id = that.selectedWithdrawTypeId;
      let type = parseInt(that.withdrawalData.type);
      if (type == 2 && that.withdrawalData.gxpay_id == "") {
        return that.$message.error("请输入您的GXPay ID");
      } else if (type == 2 && that.withdrawalData.checked == false) {
        return that.$message.error("请核对您的Gxpay ID 后再确认提现操作");
      } 
      // else if (type == 3 && that.usdt.user_withdraw_address=="") {
      //   return that.$message.error("Please setup the wallet address");
      // } 
      else {
        switch (type) {
          case 2:
            that
              .$http({
                url: "/",
                method: "post",
                data: {
                  nozzle: "withdraw",
                  token: sessionStorage.getItem("token"),
                  number: number,
                  password: password,
                  id: id,
                  type: type,
                  gxpay_id: that.withdrawalData.gxpay_id
                }
              })
              .then(function(res) {
                if (res.data.code == 1) {
                  that.$message({
                    message: res.data.msg,
                    type: "success",
                    onClose: function() {
                      that.$router.push("/myaccount/account_info?active_tab=bill");
                    }
                  });
                } else if (res.data.code == 2) {
                  that.getTradeChannel();
                } else if (res.data.code == 0 || res.data.code == -1) {
                  that.withdrawDisabled=false;
                  that.$message.error(res.data.msg);
                }
              });

            break;
            case 4:
            that
              .$http({
                url: "/",
                method: "post",
                data: {
                  nozzle: "withdraw",
                  token: sessionStorage.getItem("token"),
                  number: number,
                  password: password,
                  id: id,
                  type: type
                }
              })
              .then(function(res) {
                if (res.data.code == 1) {
                  that.$message({
                    message: res.data.msg,
                    type: "success",
                    onClose: function() {
                      that.$router.push("/myaccount/account_info?active_tab=bill");
                    }
                  });
                } else if (res.data.code == 2) {
                  that.getTradeChannel();
                } else if (res.data.code == 0 || res.data.code == -1) {
                  that.withdrawDisabled=false;
                  that.$message.error(res.data.msg);
                }
              });
            break;
            case 3:
            if (that.usdt.user_withdraw_address!='') {
                 that
                .$http({
                  url: "/",
                  method: "post",
                  data: {
                    nozzle: "withdraw",
                    token: sessionStorage.getItem("token"),
                    number: number,
                    password: password,
                    id: id,
                    type: type
                  }
                })
                .then(function(res) {
                  if (res.data.code == 1) {
                    that.$message({
                      message: res.data.msg,
                      type: "success",
                      onClose: function() {
                        that.$router.push("/myaccount/account_info?active_tab=bill");
                      }
                    });
                  } else if (res.data.code == 2) {
                    that.getTradeChannel();
                  } else if (res.data.code == 0 || res.data.code == -1) {
                    that.withdrawDisabled=false;
                    that.$message.error(res.data.msg);
                  }
                });
                 } else {
              that.usdt.userWithdrawAddressPopup = true;
            }
            break;
          default:
            if (that.withdrawalData.bankStatus) {
              that
                .$http({
                  url: "/",
                  method: "post",
                  data: {
                    nozzle: "withdraw",
                    token: sessionStorage.getItem("token"),
                    number: number,
                    password: password,
                    name: name,
                    card: card,
                    id: id,
                    type: type
                  }
                })
                .then(function(res) {
                  if (res.data.code == 1) {
                    that.$message({
                      message: res.data.msg,
                      type: "success",
                      onClose: function() {
                        that.$router.push("/myaccount/account_info?active_tab=bill");
                      }
                    });
                  } else if (res.data.code == 2) {
                    that.getTradeChannel();
                  } else if (res.data.code == 0 || res.data.code == -1) {
                    that.withdrawDisabled=false;
                    that.$message.error(res.data.msg);
                  }
                });
            } else {
              that.bank.bankStatus = true;
            }
            break;
        }
      }
    },
    getRechargetype() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "account",
            token: sessionStorage.getItem("token"),
            action: "rechargetype",
            app_version: version
          }
        })
        .then(function(res) {
          if (res.data.code == 1) {
            let resData = res.data;
            let rechargeType = (resData.data.rechargeType || []).filter(item => item.type !== 29);
            that.rechargeTypeAll = rechargeType;
            that.rechargeMethodOptions = that.normalizeRechargeMethods(resData.data.recharge_method);
            that.rechargeSourceOptions = that.normalizeRechargeSources(resData.data.recharge_source);
            that.rechargeTypesReady = true;
            that.applyRechargeFilters();
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(res.data.msg);
          }
        });
    },
    getWithdrawtype() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "withdraw_type",
            token: sessionStorage.getItem("token"),
            app_version: version
          }
        })
        .then(function(res) {
          if (res.data.code == 1) {
            let withdraweType = res.data.data;
            for (let i = 0, len = withdraweType.length; i < len; i++) {
              if (withdraweType[i].isdefault == 1) {
                that.withdrawalData.type = withdraweType[i].type;
                that.radioW = i;
              }
            }
            let type = parseInt(that.withdrawalData.type);
            let SelectedType = withdraweType.find(o => o.type == type);
            that.notice_1_10 = SelectedType.notice_1_1;
            that.notice_2_1 = SelectedType.notice_2_1;
            that.notice_2_2 = SelectedType.notice_2_2;
            that.button_text = SelectedType.button_text;
            that.selectedWithdrawTypeId = SelectedType.id;
            that.auto_fill_amounts_withdraw = SelectedType.auto_fill_amounts;
            that.withdraweType = withdraweType;
            that.auto_fill_amounts_withdraw.length > 0
              ? (that.isAutoAmountsWithdraw = true)
              : (that.isAutoAmountsWithdraw = false);
            that.selected_type = SelectedType.type;
            that.auto_fill_amounts_withdraw.length>0?that.isAutoAmountsWithdraw=true:that.isAutoAmountsWithdraw=false;
            that.selected_type=SelectedType.type;
            that.usdt.exchange_rate=SelectedType.exchange_rate?SelectedType.exchange_rate:0;
          if(SelectedType.type==3){
              that.getUserWithdrawAddress();
            }
            else if(SelectedType.type==4){
              that.loadWpayLink();
            }
            else{
               that.getAccountBank();
            }
            let minAmountDisplayEl = document.getElementById("minAmountDisplay");

            for (let i = 0; i < that.withdraweType.length; i++) {
              if (SelectedType.id === that.withdraweType[i].id) {
                if (that.withdraweType[i].min_amount === 0 || that.withdraweType[i].min_amount == null || that.withdraweType[i].min_amount == "") {
                  minAmountDisplayEl.innerHTML = "提现 " + 100 + " 元起";
                } else {
                  minAmountDisplayEl.innerHTML = "提现 " + that.withdraweType[i].min_amount + " 元起";
                }

              }
            }

          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(res.data.msg);
          }
        });
    },
    //去资金详细
    goDetailed() {
      this.$router.push({
        path: "/myaccount/account_info?active_tab=bill"
      });
    },
    //获取个人信息
    getConfig() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "user_info",
            token: sessionStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code == 1) {
            that.inputLoginPhone = res.data.data.phone1;
            //实名认证
            if (res.data.data.real != null) {
              //已认证
              that.recharge.realStatus = true;
            } else {
              //未认证
              that.recharge.realStatus = false;
            }

            if (res.data.data.bank != 0) {
              //已绑定
              that.withdrawalData.bankStatus = true;
            } else {
              //未绑定
              that.withdrawalData.bankStatus = false;
            }
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(res.data.msg);
          }
        });
    },
    qrcode(url) {
      setTimeout(function() {
        document.getElementById("qrcode").innerHTML = "";
        let qrcode = new QRCode(document.getElementById("qrcode"), {
          width: 150,
          height: 150,
          text: url // 二维码地址
        });
      }, 1500);
    },
    qrcode_yiyunhui(url) {
      setTimeout(function() {
        document.getElementById("qrcode_recharge").innerHTML = "";
        let qrcode = new QRCode(document.getElementById("qrcode_recharge"), {
          width: 150,
          height: 150,
          text: url // 二维码地址
        });
      }, 1500);
    },
    CountDown() {
      clearInterval(this.interVal);
      var duration = this.countDownTime;
      if (!isNaN(duration)) {
        var timer = duration,
          hours,
          minutes,
          seconds;
        this.interVal = setInterval(function() {
          hours = parseInt((timer / 3600) % 24, 10);
          minutes = parseInt((timer / 60) % 60, 10);
          seconds = parseInt(timer % 60, 10);

          hours = hours < 10 ? "0" + hours : hours;
          minutes = minutes < 10 ? "0" + minutes : minutes;
          seconds = seconds < 10 ? "0" + seconds : seconds;

          $("#countDown").html(hours + " : " + minutes + " : " + seconds);

          if (--timer < 0) {
            timer = duration;
            clearInterval(this.interVal);
          }
        }, 1000);
      }
    },
    //show add bankcard popup
    showBankCardPopup() {
      let that = this;
      if (
        that.activeName == "withdraw" &&
        !that.withdrawalData.isWithdrawalData
      ) {
        that
          .$confirm("请先设置提现银行卡才能提现", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          })
          .then(() => {
            that.bank.bankStatus = true;
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除"
            });
          });
      }
    },
      //show add withdraw address popup
    showWithdrawAddressPopup() {
      let that = this;
      if (
        that.activeName == "withdraw" &&
        that.usdt.user_withdraw_address==''
      ) {
        that
          .$confirm("您尚未设置提现地址，因此无法提现。请尽快设置。", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          })
          .then(() => {
            that.usdt.userWithdrawAddressPopup = true;
          })
          .catch(() => {
              that.usdt.userWithdrawAddressPopup = false;
            this.$message({
              type: "info",
              message: "已取消删除"
            });
          });
      }
    },
    // ============= get the content of trade channel popup agreement ===========
    getTradeChannel() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "trade_popup",
            token: sessionStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code == 1) {
            that.trade_rules_content_top = res.data.data.content_top;
            that.trade_rules_content_bottom = res.data.data.content_bottom;
            that.showTradeChannelPopup = true;
          } else {
          }
        });
    },
    handleTradePopupClose(done) {
      this.$router.push("/myaccount/rechange");
    },
    // ============================== Click agree the trade rules ========================
    agreeTradeRules() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "modify_trade_status",
            token: sessionStorage.getItem("token"),
            trade_channel_status: 1
          }
        })
        .then(function(res) {
          if (res.data.code == 1) {
            that.$message({
              message: res.data.msg,
              type: "success",
              duration: 1000
            });
            that.showTradeChannelPopup = false;
            that.trade_channel_status = 0;
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(res.data.msg);
          }
        });
    },
    getServerUrl() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "POST",
          data: {
            nozzle: "server_url"
          }
        })
        .then(ret => {
          let resData = ret.data;
          if (resData.code === 1) {
            window.open(resData.data, "_blank ");
          }
        });
    },
    changeInstructions(index) {
      let SelectedType = this.rechargeType[index];
      this.applySelectedType(SelectedType, index, !this.rechargeFilterMode);
    },
    toggleMethodSection() {
      this.methodSectionHidden = !this.methodSectionHidden;
      this.writeRechargeHidden("recharge_method_hidden", this.methodSectionHidden);
    },
    toggleChannelSection() {
      this.channelSectionHidden = !this.channelSectionHidden;
      this.writeRechargeHidden("recharge_channel_hidden", this.channelSectionHidden);
    },
    writeRechargeHidden(key, hidden) {
      try {
        localStorage.setItem(key, hidden ? "1" : "0");
      } catch (e) {}
    },
    selectRechargeMethod(value) {
      this.selectedMethod = value;
      this.applyRechargeFilters();
    },
    selectRechargeChannel(value) {
      this.selectedChannel = value;
      this.applyRechargeFilters();
    },
    normalizeRechargeMethods(list) {
      if (!Array.isArray(list)) {
        return [];
      }
      return list.map((item, index) => {
        if (item !== null && typeof item === "object") {
          const label =
            item.name != null && item.name !== ""
              ? item.name
              : item.label != null
              ? item.label
              : "";
          const valueKey = ["value", "code", "key", "id", "name"].find(
            key => item[key] !== undefined && item[key] !== null && item[key] !== ""
          );
          return {
            label: String(label),
            value: valueKey ? item[valueKey] : label,
            key: "method-" + index
          };
        }
        return { label: String(item), value: item, key: "method-" + index };
      });
    },
    normalizeRechargeSources(list) {
      if (!Array.isArray(list)) {
        return [];
      }
      return list.map((item, index) => ({
        id: item.id,
        name: item.name,
        key: "source-" + index + "-" + item.id
      }));
    },
    rechargeMethodValues(row) {
      let methods = row.recharge_method;
      if (typeof methods === "string") {
        try {
          methods = JSON.parse(methods);
        } catch (e) {
          methods = [];
        }
      }
      return Array.isArray(methods) ? methods : [];
    },
    rowMatchesMethod(row, methodValue) {
      const methods = this.rechargeMethodValues(row);
      if (!methods.length) {
        return false;
      }
      return methods.some(item => String(item) === String(methodValue));
    },
    applySelectedType(SelectedType, index, clearAmount) {
      if (!SelectedType) {
        this.clearRechargeSelection();
        return;
      }
      this.recharge.type = SelectedType.type;
      this.notice_1_1 = SelectedType.notice_1_1;
      this.notice_2_1 = SelectedType.notice_2_1;
      this.notice_2_2 = SelectedType.notice_2_2;
      this.selectedTypeId = SelectedType.id;
      this.recharge.recharge_content = SelectedType.recharge_content;
      this.auto_fill_amounts = SelectedType.auto_fill_amounts || [];
      this.isAutoAmounts = this.auto_fill_amounts.length > 0;
      this.radio = index;
      this.rechargeChoiceId = SelectedType.id;
      this.rechargeDefaultApplied = true;
      if (clearAmount) {
        this.recharge.number = "";
      }
    },
    clearRechargeSelection() {
      this.recharge.type = "";
      this.selectedTypeId = "";
      this.radio = "";
      this.auto_fill_amounts = [];
      this.isAutoAmounts = false;
    },
    applyRechargeFilters() {
      if (!this.userFlagsReady || !this.rechargeTypesReady) {
        return;
      }
      let list = this.rechargeTypeAll.slice();
      if (this.rechargeFilterMode) {
        if (this.isRechargeMethodShow == 1 && this.selectedMethod !== null) {
          list = list.filter(row => this.rowMatchesMethod(row, this.selectedMethod));
        }
        if (this.isRechargeChannelShow == 1 && this.selectedChannel !== null) {
          list = list.filter(row => String(row.type) === String(this.selectedChannel));
        }
        const rawAmount = this.recharge.number;
        if (rawAmount !== "" && rawAmount !== null && rawAmount !== undefined) {
          const amount = Number(rawAmount);
          if (!isNaN(amount)) {
            list = list.filter(row => {
              const min = Number(row.min_amount);
              const max = Number(row.max_amount);
              return amount >= min && amount <= max;
            });
          }
        }
      }
      const latestIndex = list.findIndex(row => row.latest_recharge == 1);
      if (latestIndex > 0) {
        const latest = list.splice(latestIndex, 1)[0];
        list.unshift(latest);
      }
      this.rechargeType = list;
      if (!this.rechargeDefaultApplied) {
        this.rechargeDefaultApplied = true;
        const latestPick = list.findIndex(row => row.latest_recharge == 1);
        const pickIndex =
          latestPick >= 0 ? latestPick : list.findIndex(row => row.isdefault == 1);
        if (pickIndex >= 0) {
          this.rechargeChoiceId = list[pickIndex].id;
        }
      }
      if (
        this.rechargeChoiceId !== "" &&
        this.rechargeChoiceId !== null &&
        typeof this.rechargeChoiceId !== "undefined"
      ) {
        const keepIndex = list.findIndex(row => row.id == this.rechargeChoiceId);
        if (keepIndex >= 0) {
          this.applySelectedType(list[keepIndex], keepIndex, false);
          return;
        }
      }
      this.clearRechargeSelection();
    },
    changeWithdrawInstructions(index) {
      let that = this;
      let SelectedType = that.withdraweType[index];
      that.withdrawalData.type = SelectedType.type;
      that.notice_1_10 = SelectedType.notice_1_1;
      that.notice_2_1 = SelectedType.notice_2_1;
      that.notice_2_2 = SelectedType.notice_2_2;
      that.button_text = SelectedType.button_text;
      that.selectedWithdrawTypeId = SelectedType.id;
      that.auto_fill_amounts_withdraw = SelectedType.auto_fill_amounts;
      that.auto_fill_amounts_withdraw.length > 0
        ? (that.isAutoAmountsWithdraw = true)
        : (that.isAutoAmountsWithdraw = false);
      that.withdrawalData.money = "";
      that.selected_type = SelectedType.type;
      that.withdrawalData.checked = false;
      that.getGxpayId();
      that.auto_fill_amounts_withdraw.length>0?that.isAutoAmountsWithdraw=true:that.isAutoAmountsWithdraw=false;
      that.withdrawalData.money = '';
      that.selected_type=SelectedType.type;
      that.usdt.exchange_rate=SelectedType.exchange_rate?SelectedType.exchange_rate:0;
      if(SelectedType.type==3){
              that.getUserWithdrawAddress();
            }
            else if(SelectedType.type==4){
              that.loadWpayLink();
            }
            else{
               that.getAccountBank();
            }
      let minAmountDisplayEl = document.getElementById("minAmountDisplay");

      for (let i = 0; i < that.withdraweType.length; i++) {
        console.log(SelectedType.id)
        console.log(that.withdraweType[i].min_amount);
        if (SelectedType.id === that.withdraweType[i].id) {
          if (that.withdraweType[i].min_amount === 0 || that.withdraweType[i].min_amount == null || that.withdraweType[i].min_amount == "") {
            minAmountDisplayEl.innerHTML = "提现 " + 100 + " 元起";
          } else {
            minAmountDisplayEl.innerHTML = "提现 " + that.withdraweType[i].min_amount + " 元起";
          }
        }
      }
    },
    handleAmount(amount) {
      let that = this;
      that.recharge.number = amount;
    },
    handleWithdrawAmount(amount) {
      let that = this;
      that.withdrawalData.money = amount;
    },
    getGxpayId() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "POST",
          data: {
            nozzle: "gxpay_thirdparty_digital_currency",
            token: sessionStorage.getItem("token")
          }
        })
        .then(ret => {
          let resData = ret.data;
          if (ret.data.code == 1) {
          if(resData.data.user == true){
           
            that.withdrawalData.gxpay_id = resData.data.numberId;
          }else{
            if(that.selected_type==2){
              window.open(resData.data.homeUrl,"_blank");
            that.$router.push("/myaccount/rechange"); 
            }

          }
        }
         
        });
    }
  },
  created() {
    try {
      this.methodSectionHidden = localStorage.getItem("recharge_method_hidden") === "1";
      this.channelSectionHidden = localStorage.getItem("recharge_channel_hidden") === "1";
    } catch (e) {}
  },
  mounted() {
    let that = this;
    // this.getCompanyBank();
    this.getCaptcha();
    this.getUserinfo();
    that.getRechargetype();
    // this.getAccountBank();
    this.getData();
    this.getConfig();
    this.macCoupon();
    that.bankFadeIn();
    this.getWithdrawChannelInfo();
    that.getWithdrawtype();
    that.getGxpayId();
    let active = that.$route.query.active;
    if (active) {
      that.activeName = active;
    }
  }
};
</script>

<style scoped>
.dialog-footer-left {
  display: flex;
  justify-content: right !important;
  gap: 1px;
}
.title {
  font-weight: bold;
  font-size: 16px;
}

.assist {
  font-size: 14px;
  line-height: 25px;
}

.weigth {
  font-weight: bold;
}

.recharge-img {
  text-align: center;
}

.hint {
  line-height: 1.5;
  width: 90%;
  margin: 0 auto 40px;
  color: red;
}

.notice-hint {
  line-height: 1.5;
  width: 90%;
  margin: 0px 28px 26px;
}

.recharge-type-group {
  display: block;
  width: 100%;
}
.rechargeRadio.el-radio.is-bordered {
  display: flex;
  align-items: flex-start;
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  height: auto;
  min-height: 36px;
  margin-left: 0 !important;
  margin-right: 0;
  margin-bottom: 8px;
  padding: 8px 10px;
  white-space: normal;
}
.rechargeRadio /deep/ .el-radio__input {
  flex: 0 0 auto;
  margin-top: 3px;
  line-height: 1;
}
.rechargeRadio /deep/ .el-radio__label {
  display: flex;
  align-items: flex-start;
  flex: 1;
  min-width: 0;
  padding-left: 8px;
  white-space: normal;
  line-height: 20px;
}
.rechargeRadio /deep/ .el-icon-bank-card {
  flex: 0 0 auto;
  margin-right: 4px;
  line-height: 20px;
}
.recharge-type-label {
  display: block;
  flex: 1;
  min-width: 0;
  line-height: 20px;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: anywhere;
}
.recharge-latest {
  display: block;
  margin-top: 2px;
  font-size: 12px;
  color: #d02e27;
  font-weight: normal;
}
.recharge-visibility-btn {
  background: #fff;
  color: #333;
  border: 1px solid #dcdfe6;
  border-radius: 14px;
  padding: 4px 14px;
  font-size: 13px;
  line-height: 1.4;
  cursor: pointer;
}
.recharge-visibility-btn.is-collapsed {
  background: #b5b5b5;
  color: #fff;
  border-color: #b5b5b5;
}
.recharge-filter-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
  margin-top: 10px;
  padding: 4px;
}
.recharge-filter-btn {
  width: 100%;
  min-height: 40px;
  height: 100%;
  box-sizing: border-box;
  border: none;
  border-radius: 20px;
  background: #e4453c;
  color: #fff;
  padding: 4px 6px;
  font-size: 12px;
  line-height: 1.2;
  cursor: pointer;
  overflow: visible;
  white-space: normal;
  word-break: break-word;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.recharge-filter-btn.is-selected {
  background: #a61b16;
  color: #fff;
  box-shadow: 0 0 0 2px #fff, 0 0 0 4px #f0b4b0;
}
.recharge-empty-tip {
  color: #d02e27;
  line-height: 32px;
}
.withdrawRadio {
  width: 100%;
  margin-left: 0 !important;
}
.el-radio.is-bordered.is-checked{
  border-color:#0D268D !important;
}
/deep/ .el-radio__input.is-checked+.el-radio__label{
  color:#0D268D !important;

}
/deep/ .el-radio__input.is-checked .el-radio__inner {
    border-color: #0D268D;
    background: #0D268D;
}

/deep/.el-button.is-round{
  padding:12px !important;
}

</style>
<style>
.checked {
  margin-left: 380px;
  margin-top: -32px;
  }

.cancel{
  background-color:#409EFF !important;
  color:white !important;
  padding:5px 25px !important;
  margin-right:150px !important;

}
.cancel :hover{
color:white !important;
}
#thirdPartyPopup .el-dialog__header {
  display: none;
}

#thirdPartyPopup .el-dialog__body {
  padding: 20px 20px;
}
#thirdPartyPopup .el-dialog__footer {
  padding: 0px 20px 20px;
}

#thirdPartyPopup .el-dialog {
  margin-top: 0 !important;
  top: 40%;
}
.crypto_qrcode {
  width: 153px;
  margin: 25px 0;
}
.el-dialog__body {
  padding: 0px 20px !important;
}
.wpay-bind-dialog {
  border-radius: 8px;
}
.wpay-bind-dialog .el-dialog__header {
  padding: 22px 24px 6px;
}
.wpay-bind-dialog .el-dialog__title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
}
.wpay-bind-dialog .el-dialog__body {
  padding: 12px 28px 28px !important;
}
.wpay-bind-tip {
  margin: 10px 0 0;
  color: #666;
  font-size: 14px;
  line-height: 1.7;
  text-align: center;
}
.wpay-bind-desc {
  margin-top: 16px;
  padding: 14px 16px;
  background: #f7f7f7;
  border-radius: 8px;
  max-height: 220px;
  overflow: auto;
  line-height: 1.6;
  color: #333;
}
.wpay-bind-action {
  text-align: center;
  margin-top: 28px;
}
.wpay-bind-action .el-button {
  border-radius: 10px;
  padding: 10px 36px;
  font-size: 14px;
}

.tradingChannelPop .el-dialog__body {
  padding: 0px 20px;
}

/* .tradingChannelPop .el-dialog__header{
  display: none;
} */
</style>



// WEBPACK FOOTER //
// src/components/capital.vue